<template>
  <div class="shade" v-show="isMove"></div>
  <div class="onlineConsultationContent" v-show="false">
    <iframe ref="onlineConsultation" v-if="iframeSrc" style="border: 0" id="onlineConsultation" width="40px" height="40px" scrolling="no" :src="iframeSrc"></iframe>
  </div>
  <ul class="cont" id="moveee" :style="`left:${x}px;top:${y}px`" ref="contactUs" @mousedown="onMouseDown">
    <div id="guideIcon" v-if="isGuide && tabNum != 4">
      <el-tooltip class="item" v-if="$route.name != 'manage' && editableTabs.length" :disabled="isMove" effect="dark" content="新手引导" placement="left-start">
        <i class="iconfont" style="font-size: 19px" @click="onGuide">&#xe63a;</i>
      </el-tooltip>
    </div>
    <el-tooltip v-if="isConsult" class="item" :disabled="isMove" effect="dark" content="在线咨询" placement="left-start">
      <i class="iconfont" @click="onClick">&#xe8c9;</i>
    </el-tooltip>
    <el-tooltip v-if="isPhone" class="item" :disabled="isMove" effect="dark" :content="phone" placement="left-start">
      <i class="iconfont" style="font-size: 19px">&#xe602;</i>
    </el-tooltip>
  </ul>
</template>
<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import useControl from "./useControl";
import useGuide from "@/hooks/guide/useGuide";
import { computed } from "@vue/reactivity";
const { handleGuide } = useGuide();
const store = useStore();
const iframeSrc = ref("");
const contactUs = ref();
const onlineConsultation = ref();
const userinfo = useStore().getters.getUserinfo();

const phone = ref("010-21423729"); //电话
if (userinfo.isChangeLogo) {
  phone.value = userinfo.oemCustomerPhone;
}

const { x, y, isMove, onMouseDown } = useControl(contactUs);

const editableTabs = computed(() => store.state.tag.tagList);
const tabNum = computed((): any => store.getters.getTabNum);
const isConsult = computed(() => !userinfo.isChangeLogo);
const isPhone = computed(() => (userinfo.isChangeLogo ? !userinfo.oemHideConsult : true));
const isGuide = computed(() => !userinfo.isChangeLogo);

onMounted(() => {
  const userinfo = useStore().getters.getUserinfo();
  const url = "/static/onlineConsultation/workphone.html";
  iframeSrc.value = `${url}?Serial=${userinfo.companynumber}&TrueName=${userinfo.realname}`;
});

const onClick = () => {
  if (!isMove.value) onlineConsultation.value.contentWindow.TQKF.kefuimg.Distrabute();
};
const onGuide = () => {
  if (!isMove.value) handleGuide();
};
</script>
<style lang="less" scoped>
.shade {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
.cont {
  position: absolute;
  padding: 0;
  margin: 0;
  z-index: 2001;
  border-radius: 5px;
  overflow: hidden;
  margin: 5px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(155, 154, 154, 0.5);
  i {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 8px;
    color: #a8baec !important;
    cursor: pointer;
    font-size: 25px;
  }
}
.onlineConsultationContent {
  position: absolute;
  top: 0px;
  width: 100%;
  right: 0;
  height: 100%;
  cursor: pointer;
}
</style>
